import { useGRNOffline } from "./useGRNOffline";

export const useOfflineGRNs = (authToken, userToken) => {
  const { grnList, loading, error, refreshGRN } = useGRNOffline(
    authToken,
    userToken
  );

  return {
    grns: grnList,
    loading,
    error,
    refetch: refreshGRN,
  };
};
